
$.validator.setDefaults({
  errorPlacement: function(error, element) {
    if (element.attr('type') == 'checkbox') {
      error.insertAfter(element.closest('label'));
    } else {
      error.insertAfter(element);
    }
  },
})

$('#newsletter-form').validate({

  messages: {
    'policy':  {
      required: "Debe aceptar la política de privacidad y condiciones de uso"
    }
  },

  submitHandler: function(form) {
    $.post(UNISKI_SETTINGS.baseURL + 'newsletter/subscribe',
    {
      email: $('[name=email]', form).val() ,
      token: 'uniski2017'
    })
    .then(function(res) {
      $('#newsletter-ok').foundation('reveal','open');
      $(':input',form).not('[type=hidden]:button').each(function() {
        $(this).val('');
      })
    });
  }
});


$('#register-form').validate({

  rules: {
    'user_registration_form[email][second]': {
      equalTo: '#user_registration_form_email_first'
    },
    'user_registration_form[plainPassword][first]': {
      is_password: true
    },
    'user_registration_form[plainPassword][second]': {
      equalTo: '#user_registration_form_plainPassword_first'
    }
  },

  messages: {
    'user_registration_form[policy]': {
      required: "Debe aceptar la política de privacidad y condiciones de uso"
    }
  }

});

$('form[name=info_form]').validate({
   messages: {
    'user_registration_form[policy]': {
      required: "Debe aceptar la política de privacidad y condiciones de uso"
    }
  }
});


$('#edit-user-form').validate({

  rules: {
    'user_edit_form[email][second]': {
      equalTo: '#user_edit_form_email_first'
    },
    'user_edit_form[plainPassword][first]': {
      is_password: true
    },
    'user_edit_form[plainPassword][second]': {
      equalTo: '#user_edit_form_plainPassword_first'
    }
  },

});
